import { serverResponse } from 'app'
import Access from 'global-utils/models/Access'
import Match from 'global-utils/models/sports/soccer/Match'

import * as actions from './InstitutionPageActions'

export default (state = actions.INSTITUTION_INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case actions.INSTITUTION_DAILY_FETCH: {
      const newState = { ...state }
      Object.assign(newState.daily, { ...action.payload, loading: true })
      return newState
    }
    case actions.INSTITUTION_DAILY_FETCH_CANCELED: {
      const newState = { ...state }
      Object.assign(newState.daily, { ...action.payload, loading: false })
      return newState
    }
    case actions.INSTITUTION_DAILY_FETCH_ERROR: {
      const newState = { ...state }
      Object.assign(newState.daily, { error: action.payload, loading: false })
      return newState
    }
    case actions.INSTITUTION_DAILY_FETCH_FULFILLED: {
      const newState = { ...state }
      Object.assign(newState.daily, { ...action.payload, loading: false })

      if (newState.daily.data[0]) {
        newState.daily.data[0].matches.forEach((match, index) => {
          newState.daily.data[0].matches[index] = new Match(match)
        })
      }
      return newState
    }

    case actions.INSTITUTION_FETCH: {
      return state
    }
    case actions.INSTITUTION_FETCH_CANCELED: {
      return state
    }
    case actions.INSTITUTION_FETCH_ERROR: {
      return {
        ...state,
        error: action.payload,
      }
    }
    case actions.INSTITUTION_FETCH_FULFILLED: {
      const newState = {
        ...serverResponse(),
        daily: {},
        tournaments: serverResponse(),
        ...action.payload,
      }
      newState.data[0].access = new Access(newState.data[0].access)
      return newState
    }

    case actions.INSTITUTION_LIKE: {
      return state
    }
    case actions.INSTITUTION_LIKE_CANCELED: {
      return state
    }
    case actions.INSTITUTION_LIKE_ERROR: {
      return state
    }
    case actions.INSTITUTION_LIKE_FULFILLED: {
      const liked = action.payload?.data?.[0]?.like
      const newState = { ...state }

      newState.data[0] = {
        ...newState.data[0],
      }

      if (liked) {
        newState.data[0].liked = {
          liked: true,
        }
        newState.data[0].following = {
          follow: true,
        }
        newState.data[0].likes_count += 1
        newState.data[0].follows_count += 1
      } else {
        newState.data[0].liked = null
        newState.data[0].following = null
        newState.data[0].likes_count -= 1
        newState.data[0].follows_count -= 1
      }
      return newState
    }

    case actions.INSTITUTION_RELATION_FETCH: {
      return { ...state }
    }
    case actions.INSTITUTION_RELATION_FETCH_CANCELED: {
      return { ...state }
    }
    case actions.INSTITUTION_RELATION_FETCH_ERROR: {
      return { ...state }
    }
    case actions.INSTITUTION_RELATION_FETCH_FULFILLED: {
      const data = action.payload.data[0]
      const newState = { ...state }
      newState.data[0] = {
        ...newState.data[0],
        ...data,
      }
      newState.data[0].access = new Access(newState.data[0].access)
      return newState
    }

    case actions.INSTITUTION_TOURNAMENT_ACTIVATION_FETCH: {
      const newState = { ...state }
      newState.tournaments.loading = true
      newState.tournaments.data = newState.tournaments.data.map((tournament) => ({
        ...tournament,
        loading: tournament.id === action.payload.tournamentId ? true : tournament.loading,
      }))
      return newState
    }
    case actions.INSTITUTION_TOURNAMENT_ACTIVATION_FETCH_CANCELED: {
      const newState = { ...state }
      newState.tournaments.loading = false
      newState.tournaments.data = newState.tournaments.data.map((tournament) => ({
        ...tournament,
        loading: false,
      }))
      return newState
    }
    case actions.INSTITUTION_TOURNAMENT_ACTIVATION_FETCH_ERROR: {
      const newState = { ...state }
      const { originalAction } = action.payload
      newState.tournaments.data = newState.tournaments.data.map((tournament) => ({
        ...tournament,
        loading: tournament.id === originalAction.tournamentId ? false : tournament.loading,
      }))
      newState.tournaments.loading = newState.tournaments.data.some((t) => !!t.loading)
      return newState
    }
    case actions.INSTITUTION_TOURNAMENT_ACTIVATION_FETCH_FULFILLED: {
      const newState = { ...state }
      const newTournament = action.payload.data[0]
      newState.tournaments.data = newState.tournaments.data.map((tournament) => ({
        ...tournament,
        ...(tournament.id === newTournament.id
          ? {
              is_active: newTournament.is_active,
              loading: false,
            }
          : {}),
      }))
      newState.tournaments.loading = newState.tournaments.data.some((t) => !!t.loading)
      return newState
    }

    case actions.INSTITUTION_TOURNAMENTS_FETCH: {
      const newState = { ...state }
      if (action.payload.institutionId !== newState.data[0].id || action.payload.page === 1) {
        newState.tournaments = serverResponse(action.payload)
      }
      newState.tournaments.loading = true
      return newState
    }
    case actions.INSTITUTION_TOURNAMENTS_FETCH_CANCELED: {
      return state
    }
    case actions.INSTITUTION_TOURNAMENTS_FETCH_ERROR: {
      const newState = { ...state }
      newState.tournaments = {
        ...newState.tournaments,
        error: action.payload,
        loading: false,
      }
      return newState
    }
    case actions.INSTITUTION_TOURNAMENTS_FETCH_FULFILLED: {
      const newState = { ...state }
      if (action.payload.pagination.current_page === 1) {
        newState.tournaments = serverResponse(action.payload, { loading: false })
        return newState
      }

      newState.tournaments = {
        ...newState.tournaments,
        ...action.payload,
        data: [...newState.tournaments.data, ...action.payload.data],
        loading: false,
      }
      return newState
    }

    default:
  }
  return state
}
